import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { GET_PLC_SAFETY_ZONES } from './actionTypes';
import { getPlcSafetyZonesSuccess, getPlcSafetyZonesError } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* getZones({ payload: { user } }) {
  try {
    const response = yield call(plcSafetyAPI.getZones, user.token);
    yield put(getPlcSafetyZonesSuccess(response));
  } catch (error) {
    yield put(getPlcSafetyZonesError(error));
  }
}

export function* watchGetPlcSafetyZones() {
  yield takeEvery(GET_PLC_SAFETY_ZONES, getZones);
}

function* getPlcSafetyZonesSaga() {
  yield all([fork(watchGetPlcSafetyZones)]);
}

export default getPlcSafetyZonesSaga;
